import { useEffect, useState, useCallback } from "react";
import { getAllRoadRecordings } from "../services/getAllRoadRecordings";

export function useRoadRecordings(relevantUrl) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRecords = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAllRoadRecordings(relevantUrl);
      if (data === "error") {
        setRecords([]);
        return;
      }
      setRecords(
        data.map(record => ({
          id: record.id,
          recordName: record.name,
          startTime: record.start_time,
          endTime: record.end_time,
          pathPoints: record.path_points,
        }))
      );
    } catch {
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }, [relevantUrl]);

  useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  return { records, loading, setRecords, fetchRecords };
}
